import errorIcon from "./errorIcon.svg";

export { errorIcon };
